/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Error_Load_UsersInputs */



/**
* | output |
* | --- |
* | "Couldn't load users." |
*
* @param {User_Error_Load_UsersInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const user_error_load_users = /** @type {((inputs?: User_Error_Load_UsersInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Error_Load_UsersInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Impossible de charger les utilisateurs.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se pudieron cargar los usuarios.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Não foi possível carregar os usuários.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile caricare gli utenti.")
	return /** @type {LocalizedString} */ ("Couldn't load users.")
});